export default "__VITE_ASSET__BMewD1I5__"